export const TAGS = {
  Expense_Exceptions: "Expense_Exceptions",
  Revenue_Exceptions: "Revenue_Exceptions",
  Apttus_Exceptions: "Apttus_Exceptions",
  Approval_Batch: "Approval_Batch",
  Apttus_Agreement_Action: "Apttus_Agreement_Action",
  Corrections: "Corrections",
  Corrections_Approval_Batch: "Corrections_Approval_Batch",
};
